import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicMemoryInstruction = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SUMMARY"
      videos={[]}
      takeaways={[
        { text: "Learn Memory traffic calculation and representation of instruction in different formats" },
        { text: "Learn all the theory part (mainly addressing modes)" },
        { text: "Another type of possible question is they will give some instructions and we need to find what type of instruction is that (new edited content)" },
        { text: "Only theoretical question from the topics Phases of Instruction Cycle and Datapath and control unit: Hardwired control unit and Micro programmed control unit(almost direct question)" },
        { text: "One numerical confirm from this module from the topic MIPS and MFLOPS (remember all the formulas)" }
      ]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicMemoryInstruction;